module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-outleft01.bbe3058a.svg";